import image1 from "../assets/t-image1.png";
import image2 from "../assets/t-image2.jpg";
import image3 from "../assets/t-image3.jpg";

export const testimonialsData = [
  {
    image: image1,
    review:
      "სწორი არჩევანი გავაკეთე Fitclub-ისა და სწორი გეგმის არჩევით, უკვე მივაღწიე ჩემს იდეალურ სხეულს!",
    name: 'მეთიუ ჰენდრიკსონი',
    status: 'მეწარმე'
  },
  {
    image: image2,
    review: 'ლორემ იპსუმ დოლორ სით ამეთ კონსექტეტურ ადიპისიცინგ ელიტ. კომოდი იპსამ, აბ ითაქუე ნამ პერფერენდისი impedit sint.',
    name: 'ჯონ კევინი',
    status: 'მწვრთნელი'
  },
  {
    image: image3,
    review: 'ლორემ იპსუმ დოლორ სით, ამეთ კონსექტეტურ ადიპისიცინგ ელიტ. მინიმა ასპერნატურ ქუოდ ვოლუპტატემ.',
    name: 'ფრანკლინი',
    status: "კლიენტი"
  }
];
